const AdminRoute = ({ children }) => {
  return children;
};

export default AdminRoute;
